var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39637b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_5",
    "data-name": "Warstwa 5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.49 10.33 5.51 10.27 5.51 0.83 6.49 0.83 6.49 10.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 11.75,
    width: 12,
    height: 0.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6 0 12 6.44 11.29 7 6 1.33 0.71 7 0 6.44 6 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIco);
export default __webpack_public_path__ + "static/media/upload-ico.30cb24f3ec0f7c70445980e0efc34b28.svg";
export { ForwardRef as ReactComponent };